import React from 'react'
import './header.css'

function Header() {
  return ( 
     <div className='blogHead'>
    <span>Blog Page</span>
    </div>
  
  )
}

export default Header
